import {Dispatch, SetStateAction, useEffect, useRef} from "react";
import Alert from 'react-bootstrap/Alert';
import {Placement} from 'react-bootstrap/types';
import {Truncate} from "./Truncate";

export interface AlertProps {
    message : string | undefined
    setMessage?: Dispatch<SetStateAction<string | undefined>>
    variant? : "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark"
    tooltipPlacement?: Placement
    scrollIntoView?: boolean
    className?: string
}

/**
 * Shows an alert if the error message is set, i.e., is defined. Unless scrollIntoView is false, the alert is
 * scrolled into view when a message appears or changes, so an alert at the top of a long form is not missed.
 * The scroll is not repeated on a re-render (typing in a field) and does nothing when the alert is visible
 */
export const RenderAlert = ({message, setMessage, tooltipPlacement, variant = "danger", scrollIntoView = true, className}: AlertProps) =>
{
    const alertRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (scrollIntoView && message !== undefined) {
            alertRef.current?.scrollIntoView({block: "nearest"});
        }
    }, [message, scrollIntoView]);

    if (message != undefined) {
        return (
            <Alert ref={alertRef}
                   className={"text-break " + className}
                   variant={variant}
                   onClose={() => {if (setMessage !== undefined) setMessage(undefined)}}
                   dismissible={setMessage !== undefined}
            >
                <Truncate value={message} maxLength={240} placement={tooltipPlacement} />
            </Alert>
        );
    }
};
